/**
 * name:http服务
 * describe:对http请求做统一处理
 * author:Angular那些事 
 * date:2017/6/3
 * time:11:29
 */
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';


@Injectable()
export class HttpInterceptorService {

    constructor(private http: Http) {
    }

    /**
    * 统一发送请求
    * @param params
    * @returns {Promise<{success: boolean, msg: string}>|Promise<R>}
    */
    public request(params: any): any {
        if (params['method'] == 'post' || params['method'] == 'POST') {
            return this.post(params['url'], params['data']);
        }
        else {
            return this.get(params['url'], params['data']);
        }
    }

    /**
    * get请求
    * @param url 接口地址
    * @param params 参数
    * @returns {Promise<R>|Promise<U>}
    */
    public get(url: string, params: any): any {
        return this.http.get(url, { search: params })
            .toPromise()
            .then(this.handleSuccess)
            .catch(res => this.handleError(res));
    }

    /**
    * post请求
    * @param url 接口地址
    * @param params 参数
    * @returns {Promise<R>|Promise<U>}
    */
    public post(url: string, params: any) {
        return this.http.post(url, params)
            .toPromise()
            .then(this.handleSuccess)
            .catch(res => this.handleError(res));
    }

    /**
    * 处理请求成功
    * @param res
    * @returns {{data: (string|null|((node:any)=>any)
    */
    private handleSuccess(res: Response) {
        let body = res["_body"];
        if (body) {
            return {
                data: res.json().content || {},
                page: res.json().page || {},
                statusText: res.statusText,
                status: res.status,
                success: true
            }
        }
        else {
            return {
                statusText: res.statusText,
                status: res.status,
                success: true
            }
        }
    }

    /**
    * 
    * @param error
    * @returns {void|Promise<string>|Promise<T>|any}
    */
    private handleError(error) {
        console.log(error);
        let msg = 'error';
        if (error.status == 400) {
            console.log('page not found');
        }
        if (error.status == 404) {

            console.error('path is not right');
        }
        if (error.status == 500) {
            console.error('error to get server');
        }
        console.log(error);
        return { success: false, msg: msg };
    }

}
